module.exports = __webpack_public_path__ + "static/media/RESTAURANT-INFO-EXPECTATIONS.6fe8dc56.pdf";